import { regionCodes } from "brandRegionConfig";
import type { RegionCode } from "core/entities";

export function isValidRegion(
  input: unknown,
  validRegionCodes: readonly RegionCode[] = regionCodes
): input is RegionCode {
  if (typeof input !== "string") {
    return false;
  }
  return validRegionCodes.includes(input.toLowerCase() as RegionCode);
}
